import { setGoogleMapsStatus, SET_GOOGLE_MAPS_STATUS } from '../../actions/system/set-google-maps-status';
import { GoogleMapsStatus } from '../../../types/map/maps';
import { ActionType } from 'typesafe-actions';

export type SetGoogleMapsStatusAction = ActionType<typeof setGoogleMapsStatus>;

export default(state = GoogleMapsStatus.PENDING, action: SetGoogleMapsStatusAction) => {
    switch(action.type){
        case SET_GOOGLE_MAPS_STATUS:
            return action.payload;

        default:
            return state;
    }
}
